import axios from "axios";

export const addFeelingApi = async (body) => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/feeling`, body);
    return data;
};
export const getFeelingByUserApi = async (id, session_ID) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/feeling/${id}?session_ID=${encodeURIComponent(JSON.stringify(session_ID))}`);
    return data.data;
};